import styles from './Login.module.css';

interface PasswordHelperProps {
  meetsMinLength: boolean;
  hasUppercase: boolean;
  hasLowercase: boolean;
  hasNumber: boolean;
  hasSpecialChar: boolean;
}

const PasswordHelper = (
  {
    meetsMinLength,
    hasUppercase,
    hasLowercase,
    hasNumber,
    hasSpecialChar
  } : PasswordHelperProps): React.JSX.Element => {

  return (
    <div
      data-testid="password-requirements"
      className={styles['password-req-container']}
    >
      <div className={styles['password-req-column']}>
        <div className={styles['password-req-row']}>
          <div className={styles['password-req-check']}>{meetsMinLength ? '✓' : ''}</div>
          <div>At least 8 characters</div>
        </div>
        <div className={styles['password-req-row']}>
          <div className={styles['password-req-check']}>{hasUppercase ? '✓' : ''}</div>
          <div>At least 1 upper case letter</div>
        </div>
        <div className={styles['password-req-row']}>
          <div className={styles['password-req-check']}>{hasLowercase ? '✓' : ''}</div>
          <div>At least 1 lower case letter</div>
        </div>
      </div>

      <div className={styles['password-req-column']}>
        <div className={styles['password-req-row']}>
          <div className={styles['password-req-check']}>{ hasNumber ? '✓' : ''}</div>
          <div >At least 1 number</div>
        </div>

        <div className={styles['password-req-row']}>
          <div className={styles['password-req-check']}>{ hasSpecialChar ? '✓' : ''}</div>
          <div>At least 1 special character</div>
        </div>
      </div>
    </div>
  );
};
export default PasswordHelper;
